export function includes(haystack, needle) {
    const _haystack = haystack;
    return _haystack.includes(needle);
}
export function hasAtLeast(array, length) {
    return array.length >= length;
}
export const UP_ARROW = "\u007f";
export const DOWN_ARROW = "\u0080";
const uplinkResponseAttributes = ["WU", "AN", "R", "Y", "NE", "N"];
const downlinkResponseAttributes = ["Y", "N"];
export function isDownlinkResponseAttributeType(type) {
    return includes(downlinkResponseAttributes, type);
}
export function isUplinkResponseAttributeType(type) {
    return includes(uplinkResponseAttributes, type);
}
// see ICAO GOLD manual, section A.3
// possible required response
export const validUplinkResponseMap = {
    /** WILCO, UNABLE, STANDBY, NOT CURRENT DATA AUTHORITY, NOT AUTHORIZED NEXT DATA AUTHORITY, LOGICAL ACKNOWLEDGEMENT, ERROR */
    WU: ["DM0", "DM1", "DM2", "DM62", "DM63", "DM100", "DM107"],
    /** STANDBY, AFFIRM, NEGATIVE, NOT CURRENT DATA AUTHORITY, NOT AUTHORIZED NEXT DATA AUTHORITY, LOGICAL ACKNOWLEDGEMENT, ERROR */
    AN: ["DM2", "DM4", "DM5", "DM62", "DM63", "DM100", "DM107"],
    /** UNABLE, STANDBY, ROGER, NOT CURRENT DATA AUTHORITY, NOT AUTHORIZED NEXT DATA AUTHORITY, LOGICAL ACKNOWLEDGEMENT, ERROR */
    R: ["DM1", "DM2", "DM3", "DM62", "DM63", "DM100", "DM107"],
};
export const msgResponseList = [
    "DM0",
    "DM1",
    "DM3",
    "DM5",
    "DM2",
    "DM62",
    "DM63",
    "DM100",
    "DM107",
    "UM1",
    "UM2",
    "UM3",
    "UM4",
    "UM5",
    "UM211",
    "UM235",
    "UM237",
];
const createUplinkMsgDescription = (numParams, description, responseAttr = "N", eramDescription) => ({
    numParams,
    description,
    responseAttr,
    eramDescription,
});
const createDownlinkMsgDescription = (numParams, description, responseAttr = "N", eramDescription) => ({
    numParams,
    description,
    responseAttr,
    eramDescription,
});
export const cpdlcMsgDescriptionMap = {
    UM0: createUplinkMsgDescription(0, () => "UNABLE"),
    UM1: createUplinkMsgDescription(0, () => "STANDBY"),
    UM2: createUplinkMsgDescription(0, () => "REQUEST DEFERRED"),
    UM3: createUplinkMsgDescription(0, () => "ROGER"),
    UM4: createUplinkMsgDescription(0, () => "AFFIRM"),
    UM5: createUplinkMsgDescription(0, () => "NEGATIVE"),
    UM211: createUplinkMsgDescription(0, () => "REQUEST FORWARDED"),
    UM235: createUplinkMsgDescription(0, () => "ROGER 7500"),
    UM237: createUplinkMsgDescription(0, () => "REQUEST AGAIN WITH NEXT UNIT"),
    // vertical clearances
    UM6: createUplinkMsgDescription(1, ([alt]) => `EXPECT ${alt}`, "WU"),
    UM7: createUplinkMsgDescription(1, ([time]) => `EXPECT CLIMB AT ${time}`, "R"),
    UM8: createUplinkMsgDescription(1, ([fix]) => `EXPECT CLIMB AT ${fix}`, "R"),
    UM9: createUplinkMsgDescription(1, ([time]) => `EXPECT DESCENT AT ${time}`, "R"),
    UM10: createUplinkMsgDescription(1, ([fix]) => `EXPECT DESCENT AT ${fix}`, "R"),
    UM11: createUplinkMsgDescription(1, ([time]) => `EXPECT CRUISE CLIMB AT ${time}`, "WU"),
    UM12: createUplinkMsgDescription(1, ([fix]) => `EXPECT CRUISE CLIMB AT ${fix}`, "WU"),
    UM19: createUplinkMsgDescription(1, ([alt]) => `MAINTAIN ${alt}`, "WU"),
    UM20: createUplinkMsgDescription(1, ([alt]) => `CLIMB TO AND MAINTAIN ${alt}`, "WU", ([alt]) => `${UP_ARROW}${alt}`),
    UM21: createUplinkMsgDescription(2, ([time, alt]) => `AT ${time} CLIMB TO AND MAINTAIN ${alt}`, "WU"),
    UM22: createUplinkMsgDescription(2, ([fix, alt]) => `AT ${fix} CLIMB TO AND MAINTAIN ${alt}`, "WU"),
    UM23: createUplinkMsgDescription(1, ([alt]) => `DESCEND TO AND MAINTAIN ${alt}`, "WU", ([alt]) => `${DOWN_ARROW}${alt}`),
    UM24: createUplinkMsgDescription(2, ([time, alt]) => `AT ${time} DESCEND TO AND MAINTAIN ${alt}`, "WU"),
    UM25: createUplinkMsgDescription(2, ([fix, alt]) => `AT ${fix} DESCEND TO AND MAINTAIN ${alt}`, "WU"),
    UM26: createUplinkMsgDescription(2, ([alt, time]) => `CLIMB TO REACH ${alt} BY ${time}`, "WU"),
    UM27: createUplinkMsgDescription(2, ([alt, fix]) => `CLIMB TO REACH ${alt} BY ${fix}`, "WU"),
    UM28: createUplinkMsgDescription(2, ([alt, time]) => `DESCEND TO REACH ${alt} BY ${time}`, "WU"),
    UM29: createUplinkMsgDescription(2, ([alt, fix]) => `DESCEND TO REACH ${alt} BY ${fix}`, "WU"),
    UM192: createUplinkMsgDescription(2, ([alt, fix]) => `REACH ${alt} BY ${fix}`, "WU"),
    UM209: createUplinkMsgDescription(2, ([alt, fix]) => `REACH ${alt} BY ${fix}`, "WU"),
    UM30: createUplinkMsgDescription(2, ([lower, upper]) => `MAINTAIN BLOCK ${lower} TO ${upper}`, "WU", ([lower, upper]) => `${lower}B${upper}`),
    UM31: createUplinkMsgDescription(2, ([lower, upper]) => `CLIMB TO AND MAINTAIN BLOCK ${lower} TO ${upper}`, "WU"),
    UM32: createUplinkMsgDescription(2, ([lower, upper]) => `DESCEND TO AND MAINTAIN BLOCK ${lower} TO ${upper}`, "WU"),
    UM34: createUplinkMsgDescription(1, ([alt]) => `CRUISE CLIMB TO  ${alt}`, "WU"),
    UM35: createUplinkMsgDescription(1, ([fix]) => `WHEN ABOVE ${fix} COMMENCE CRUISE CLIMB`, "WU"),
    UM219: createUplinkMsgDescription(1, ([alt]) => `STOP CLIMB AT ${alt}`, "WU"),
    UM220: createUplinkMsgDescription(1, ([alt]) => `STOP DESCENT AT ${alt}`, "WU"),
    UM36: createUplinkMsgDescription(1, ([alt]) => `EXPEDITE CLIMB TO ${alt}`, "WU", ([alt]) => `EXP ${UP_ARROW}${alt}`),
    UM37: createUplinkMsgDescription(1, ([alt]) => `EXPEDITE DESCENT TO ${alt}`, "WU", ([alt]) => `EXP ${DOWN_ARROW}${alt}`),
    UM38: createUplinkMsgDescription(1, ([alt]) => `IMMEDIATELY CLIMB TO ${alt}`, "WU", ([alt]) => `IMM ${UP_ARROW}${alt}`),
    UM39: createUplinkMsgDescription(1, ([alt]) => `IMMEDIATELY DESCEND TO ${alt}`, "WU", ([alt]) => `IMM ${DOWN_ARROW}${alt}`),
    UM171: createUplinkMsgDescription(1, ([rate]) => `CLIMB AT ${rate} MINIMUM`, "WU"),
    UM172: createUplinkMsgDescription(1, ([rate]) => `CLIMB AT ${rate} MINIMUM`, "WU"),
    UM173: createUplinkMsgDescription(1, ([rate]) => `DESCEND AT ${rate} MINIMUM`, "WU"),
    UM174: createUplinkMsgDescription(1, ([rate]) => `DESCEND AT ${rate} MINIMUM`, "WU"),
    // crossing restrictions
    UM46: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT ${alt}`, "WU"),
    UM47: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT OR ABOVE ${alt}`, "WU", ([fix, alt]) => `${fix}/A${alt}`),
    UM48: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT OR BELOW ${alt}`, "WU", ([fix, alt]) => `${fix}/B${alt}`),
    UM49: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT AND MAINTAIN ${alt}`, "WU", ([fix, alt]) => `${fix}/${alt}`),
    UM50: createUplinkMsgDescription(3, ([fix, lower, upper]) => `CROSS ${fix} BETWEEN ${lower} AND ${upper}`, "WU"),
    UM51: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT ${alt}`, "WU", ([fix, alt]) => `${fix} ${alt}`),
    UM52: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT OR BEFORE ${alt}`, "WU"),
    UM53: createUplinkMsgDescription(2, ([fix, alt]) => `CROSS ${fix} AT OR AFTER ${alt}`, "WU"),
    UM54: createUplinkMsgDescription(3, ([fix, lower, upper]) => `CROSS ${fix} BETWEEN ${lower} AND ${upper}`, "WU"),
    UM55: createUplinkMsgDescription(2, ([fix, speed]) => `CROSS ${fix} AT ${speed}`, "WU", ([fix, speed]) => `${fix}/${speed}`),
    UM56: createUplinkMsgDescription(2, ([fix, speed]) => `CROSS ${fix} AT OR LESS THAN ${speed}`, "WU", ([fix, speed]) => `${fix}/${speed}-`),
    UM57: createUplinkMsgDescription(2, ([fix, speed]) => `CROSS ${fix} AT OR GREATER THAN ${speed}`, "WU", ([fix, speed]) => `${fix}/${speed}+`),
    UM58: createUplinkMsgDescription(3, ([fix, alt, speed]) => `CROSS ${fix} AT ${alt} AT ${speed}`, "WU", ([fix, alt, speed]) => `${fix}/${alt}/${speed}`),
    UM59: createUplinkMsgDescription(3, ([fix, time, speed]) => `CROSS ${fix} AT OR BEFORE ${time} AT ${speed}`, "WU"),
    UM60: createUplinkMsgDescription(3, ([fix, time, speed]) => `CROSS ${fix} AT OR AFTER ${time} AT ${speed}`, "WU"),
    UM61: createUplinkMsgDescription(3, ([fix, alt, speed]) => `CROSS ${fix} AT AND MAINTAIN ${alt} AT ${speed}`, "WU", ([fix, alt, speed]) => `${fix}/${alt}/${speed}`),
    UM62: createUplinkMsgDescription(3, ([time, fix, alt]) => `AT ${time} CROSS ${fix} AT AND MAINTAIN ${alt}`, "WU"),
    UM63: createUplinkMsgDescription(4, ([time, fix, alt, speed]) => `AT ${time} CROSS ${fix} AT AND MAINTAIN ${alt} AT ${speed}`, "WU"),
    // Lateral Offsets
    UM64: createUplinkMsgDescription(2, ([distance, direction]) => `OFFSET ${distance} ${direction} OF ROUTE `, "WU"),
    UM65: createUplinkMsgDescription(3, ([fix, dist, direction]) => `AT ${fix} OFFSET ${dist} ${direction} OF ROUTE`, "WU"),
    UM66: createUplinkMsgDescription(3, ([time, dist, direction]) => `AT ${time} OFFSET ${dist} ${direction} OF ROUTE`, "WU"),
    UM67: createUplinkMsgDescription(0, () => `PROCEED BACK ON ROUTE`, "WU"),
    UM68: createUplinkMsgDescription(1, ([fix]) => `REJOIN ROUTE BY ${fix}`, "WU"),
    UM69: createUplinkMsgDescription(1, ([time]) => `REJOIN ROUTE BY ${time}`, "WU"),
    UM70: createUplinkMsgDescription(1, ([fix]) => `EXPECT BACK ON ROUTE BY ${fix}`, "R"),
    UM71: createUplinkMsgDescription(1, ([time]) => `EXPECT BACK ON ROUTE BY ${time}`, "R"),
    UM72: createUplinkMsgDescription(0, () => `RESUME OWN NAVIGATION`, "WU"),
    // Route Modifications
    UM73: createUplinkMsgDescription(1, ([text]) => `${text}`, "WU"),
    UM74: createUplinkMsgDescription(1, ([fix]) => `PROCEED DIRECT TO ${fix}`, "WU", ([fix]) => `DRCT ${fix}`),
    UM75: createUplinkMsgDescription(1, ([fix]) => `WHEN ABLE PROCEED DIRECT TO ${fix}`, "WU", ([fix]) => `WA DRCT ${fix}`),
    UM76: createUplinkMsgDescription(2, ([time, fix]) => `AT ${time} PROCEED DIRECT TO ${fix}`, "WU"),
    UM77: createUplinkMsgDescription(2, ([fix1, fix2]) => `AT ${fix1} PROCEED DIRECT TO ${fix2}`, "WU"),
    UM78: createUplinkMsgDescription(2, ([altitude, fix2]) => `AT ${altitude} PROCEED DIRECT TO ${fix2}`, "WU"),
    UM79: createUplinkMsgDescription(2, ([destination, route]) => `CLEARED TO ${destination} VIA ${route}`, "WU"),
    UM80: createUplinkMsgDescription(1, ([route]) => `CLEARED ${route}`, "WU", ([route]) => `CLRD ${route}`),
    UM81: createUplinkMsgDescription(1, ([procedureName]) => `CLEARED ${procedureName}`, "WU", ([procedureName]) => `CLRD ${procedureName}`),
    UM82: createUplinkMsgDescription(2, ([distance, direction]) => `CLEARED TO DEVIATE UP TO ${distance} ${direction} OF ROUTE`, "WU", ([upto, direction]) => `CLRD DEV ${upto} ${direction}`),
    UM83: createUplinkMsgDescription(2, ([fix, procedureName]) => `AT ${fix} CLEARED ${procedureName}`, "WU"),
    UM84: createUplinkMsgDescription(2, ([fix, route]) => `AT ${fix} CLEARED ${route}`, "WU"),
    UM85: createUplinkMsgDescription(1, ([expect]) => `EXPECT ${expect}`, "WU"),
    UM86: createUplinkMsgDescription(2, ([fix, expect]) => `AT ${fix} EXPECT ${expect}`, "WU"),
    UM87: createUplinkMsgDescription(1, ([fix]) => `EXPECT DIRECT TO ${fix}`, "WU"),
    UM88: createUplinkMsgDescription(2, ([fix, direct]) => `AT ${fix} EXPECT DIRECT TO ${direct}`, "WU"),
    UM89: createUplinkMsgDescription(2, ([fix, direct]) => `AT ${fix} EXPECT DIRECT TO ${direct}`, "WU"),
    UM90: createUplinkMsgDescription(2, ([fix, direct]) => `AT ${fix} EXPECT DIRECT TO ${direct}`, "WU"),
    UM236: createUplinkMsgDescription(0, () => "LEAVE CONTROLLED AIRSPACE", "WU"),
    // Hold
    UM91: createUplinkMsgDescription(5, ([fix, alt, inbTrack, turnDir, arg]) => `HOLD AT ${fix} MAINTAIN ${alt} INBOUND TRACK ${inbTrack} ${turnDir} TURNS ${arg}}`, "WU", ([fix, alt, inbTrack, turnDir, arg]) => `HOLD ${fix}/${alt}/${inbTrack}/${turnDir}/${arg}`),
    UM92: createUplinkMsgDescription(2, ([fix, alt]) => `HOLD AT ${fix} AS PUBLISHED MAINTAIN ${alt}`, "WU", ([fix, alt]) => `HOLD ${fix}/${alt}`),
    UM93: createUplinkMsgDescription(1, ([efc]) => `EXPECT FURTHER CLEARANCE AT ${efc}`, "R", ([efc]) => `EFC ${efc}`),
    UM94: createUplinkMsgDescription(2, ([dir, heading]) => `TURN ${dir} HEADING ${heading}`, "WU", ([dir, heading]) => `${dir} HDG ${heading}`),
    UM95: createUplinkMsgDescription(2, ([dir, degrees]) => `TURN ${dir} GROUND TRACK ${degrees}`, "WU", ([dir, degrees]) => `${dir} TRK ${degrees}`),
    UM215: createUplinkMsgDescription(2, ([dir, degrees]) => `TURN ${dir} ${degrees} DEGREES`, "WU", ([dir, degrees]) => `${degrees}${dir}`),
    UM190: createUplinkMsgDescription(1, ([heading]) => `FLY HEADING ${heading}`, "WU", ([heading]) => `HDG ${heading}`),
    UM96: createUplinkMsgDescription(0, () => "CONTINUE PRESENT HEADING", "WU", () => "PH"),
    UM97: createUplinkMsgDescription(2, ([fix, heading]) => `AT ${fix} FLY HEADING ${heading}`, "WU"),
    UM98: createUplinkMsgDescription(2, ([dir, heading]) => `IMMEDIATELY TURN ${dir} HEADING ${heading}`, "WU"),
    UM99: createUplinkMsgDescription(1, ([procedureName]) => `EXPECT ${procedureName}`, "R"),
    UM221: createUplinkMsgDescription(1, ([heading]) => `STOP TURN HEADING ${heading}`, "WU"),
    // Speed Changes
    UM100: createUplinkMsgDescription(2, ([fix, expect]) => `AT ${fix} EXPECT ${expect}`, "WU"),
    UM101: createUplinkMsgDescription(2, ([fix, expect]) => `AT ${fix} EXPECT ${expect}`, "WU"),
    UM102: createUplinkMsgDescription(2, ([fix, expect]) => `AT ${fix} EXPECT ${expect}`, "WU"),
    UM103: createUplinkMsgDescription(3, ([fix, lower, upper]) => `AT ${fix} EXPECT ${lower} TO ${upper}`, "WU"),
    UM104: createUplinkMsgDescription(3, ([fix, lower, upper]) => `AT ${fix} EXPECT ${lower} TO ${upper}`, "WU"),
    UM105: createUplinkMsgDescription(3, ([fix, lower, upper]) => `AT ${fix} EXPECT ${lower} TO ${upper}`, "WU"),
    UM106: createUplinkMsgDescription(1, ([spd]) => `MAINTAIN ${spd}`, "WU", ([spd]) => spd),
    UM188: createUplinkMsgDescription(2, ([fix, spd]) => `AFTER PASSING ${fix} MAINTAIN ${spd}`, "WU"),
    UM107: createUplinkMsgDescription(0, () => "MAINTAIN PRESENT SPEED", "WU", () => "PRES SPD"),
    UM108: createUplinkMsgDescription(1, ([spd]) => `MAINTAIN ${spd} OR GREATER`, "WU", ([spd]) => `${spd}+`),
    UM109: createUplinkMsgDescription(1, ([spd]) => `MAINTAIN ${spd} OR LESS`, "WU", ([spd]) => `${spd}-`),
    UM110: createUplinkMsgDescription(2, ([lower, upper]) => `MAINTAIN ${lower} TO ${upper}`, "WU"),
    UM111: createUplinkMsgDescription(1, ([spd]) => `INCREASE SPEED TO ${spd}`, "WU", ([spd]) => `INC SPD TO ${spd}`),
    UM112: createUplinkMsgDescription(1, ([spd]) => `INCREASE SPEED TO ${spd} OR GREATER`, "WU", ([spd]) => `INC SPD TO ${spd}+`),
    UM113: createUplinkMsgDescription(1, ([spd]) => `REDUCE SPEED TO ${spd}`, "WU", ([spd]) => `RED SPD TO ${spd}`),
    UM114: createUplinkMsgDescription(1, ([spd]) => `REDUCE SPEED TO ${spd} OR LESS`, "WU", ([spd]) => `RED SPD TO ${spd}-`),
    UM115: createUplinkMsgDescription(1, ([spd]) => `DO NOT EXCEED ${spd}`, "WU"),
    UM116: createUplinkMsgDescription(0, () => "RESUME NORMAL SPEED", "WU", () => "RNS"),
    UM189: createUplinkMsgDescription(1, ([spd]) => `ADJUST SPEED TO ${spd}`, "WU"),
    UM222: createUplinkMsgDescription(0, () => "NO SPEED RESTRICTION", "WU"),
    UM223: createUplinkMsgDescription(0, () => "REDUCE TO MINIMUM APPROACH SPEED", "WU"),
    // Contact/Monitor/Surveillance Requests
    UM117: createUplinkMsgDescription(2, ([name, freq]) => `CONTACT ${name} ${freq}`, "WU"),
    UM118: createUplinkMsgDescription(3, ([fix, name, freq]) => `AT ${fix} CONTACT ${name} ${freq}`, "WU"),
    UM119: createUplinkMsgDescription(3, ([time, name, freq]) => `AT ${time} CONTACT ${name} ${freq}`, "WU"),
    UM238: createUplinkMsgDescription(1, ([freq]) => `SECONDARY FREQUENCY ${freq}`, "WU"),
    UM120: createUplinkMsgDescription(2, ([name, freq]) => `MONITOR ${name} ${freq}`, "WU"),
    UM121: createUplinkMsgDescription(3, ([fix, name, freq]) => `AT ${fix} MONITOR ${name} ${freq}`, "WU"),
    UM122: createUplinkMsgDescription(3, ([time, name, freq]) => `AT ${time} MONITOR ${name} ${freq}`, "WU"),
    UM123: createUplinkMsgDescription(1, ([squawk]) => `SQUAWK ${squawk}`, "WU"),
    UM124: createUplinkMsgDescription(0, () => "STOP SQUAWK", "WU"),
    UM239: createUplinkMsgDescription(0, () => "STOP ADS-B TRANSMISSION", "WU"),
    UM125: createUplinkMsgDescription(0, () => "SQUAWK MODE CHARLIE", "WU"),
    UM240: createUplinkMsgDescription(0, () => "TRANSMIT ADS-B ALTITUDE", "WU"),
    UM126: createUplinkMsgDescription(0, () => "STOP SQUAWK MODE CHARLIE", "WU"),
    UM179: createUplinkMsgDescription(0, () => "SQUAWK IDENT", "WU"),
    UM242: createUplinkMsgDescription(0, () => "TRANSMIT ADS-B IDENT", "WU"),
    UM243: createUplinkMsgDescription(0, () => "REPORT CLEAR OF WEATHER", "WU"),
    // Report/Confirmation Requests
    UM127: createUplinkMsgDescription(0, () => "REPORT BACK ON ROUTE", "R"),
    UM128: createUplinkMsgDescription(1, ([alt]) => `REPORT LEAVING ${alt}`, "R"),
    UM129: createUplinkMsgDescription(1, ([lvl]) => `REPORT MAINTAINING LEVEL ${lvl}`, "R"),
    UM200: createUplinkMsgDescription(1, ([speed]) => `REPORT MAINTAINING ${speed}`, "R"),
    UM180: createUplinkMsgDescription(2, ([lower, upper]) => `REPORT REACHING BLOCK LEVEL ${lower} TO ${upper}`, "R"),
    UM130: createUplinkMsgDescription(1, ([fix]) => `REPORT PASSING ${fix}`, "R"),
    UM181: createUplinkMsgDescription(2, ([dist, from]) => `REPORT DISTANCE ${dist} ${from}`, "R"),
    UM184: createUplinkMsgDescription(3, ([time, dist, from]) => `AT TIME ${time} REPORT DISTANCE ${dist} ${from}`, "R"),
    UM228: createUplinkMsgDescription(1, ([fix]) => `REPORT ETA ${fix}`, "Y"),
    UM131: createUplinkMsgDescription(0, () => "REPORT REMAINING FUEL AND PERSONS ON BOARD", "Y"),
    UM132: createUplinkMsgDescription(0, () => "REPORT POSITION", "Y"),
    UM133: createUplinkMsgDescription(0, () => "REPORT PRESENT LEVEL", "Y"),
    UM134: createUplinkMsgDescription(0, () => "CONFIRM SPEED", "Y"),
    UM135: createUplinkMsgDescription(0, () => "CONFIRM ASSIGNED ALTITUDE", "Y"),
    UM136: createUplinkMsgDescription(0, () => "CONFIRM ASSIGNED SPEED", "Y"),
    UM137: createUplinkMsgDescription(0, () => "CONFIRM ASSIGNED ROUTE", "Y"),
    UM138: createUplinkMsgDescription(0, () => "CONFIRM TIME OVER REPORTED WAYPOINT", "Y"),
    UM139: createUplinkMsgDescription(0, () => "CONFIRM REPORTED WAYPOINT", "Y"),
    UM140: createUplinkMsgDescription(0, () => "CONFIRM NEXT WAYPOINT", "Y"),
    UM141: createUplinkMsgDescription(0, () => "CONFIRM NEXT WAYPOINT ETA", "Y"),
    UM142: createUplinkMsgDescription(0, () => "CONFIRM ENSUING WAYPOINT", "Y"),
    UM143: createUplinkMsgDescription(0, () => "CONFIRM REQUEST", "Y"),
    UM144: createUplinkMsgDescription(0, () => "CONFIRM SQUAWK", "Y"),
    UM145: createUplinkMsgDescription(0, () => "REPORT HEADING", "Y"),
    UM146: createUplinkMsgDescription(0, () => "REPORT GROUND TRACK", "Y"),
    UM182: createUplinkMsgDescription(0, () => "CONFIRM ATIS CODE", "Y"),
    UM147: createUplinkMsgDescription(0, () => "REQUEST POSITION REPORT", "Y"),
    UM216: createUplinkMsgDescription(0, () => "REQUEST FLIGHT PLAN", "Y"),
    UM217: createUplinkMsgDescription(0, () => "REPORT ARRIVAL", "Y"),
    UM229: createUplinkMsgDescription(0, () => "REPORT ALTERNATE AERODROME", "Y"),
    UM231: createUplinkMsgDescription(0, () => "STATE PREFERRED LEVEL", "Y"),
    UM232: createUplinkMsgDescription(0, () => "STATE TOP OF DESCENT", "Y"),
    UM148: createUplinkMsgDescription(1, ([req]) => `WHEN CAN YOU ACCEPT ${req}`, "Y"),
    UM149: createUplinkMsgDescription(2, ([req, fix]) => `CAN YOU ACCEPT ${req} AT ${fix}`, "Y"),
    UM150: createUplinkMsgDescription(2, ([req, time]) => `CAN YOU ACCEPT ${req} AT ${time}`, "Y"),
    UM151: createUplinkMsgDescription(1, ([req]) => `WHEN CAN YOU ACCEPT ${req}`, "Y"),
    UM152: createUplinkMsgDescription(2, ([req, offset]) => `WHEN CAN YOU ACCEPT ${req} ${offset} OFFSET`, "Y"),
    // Air Traffic Advisories
    UM153: createUplinkMsgDescription(1, ([altim]) => `ALTIMETER ${altim}`, "R", ([altim]) => `A${altim}`),
    UM213: createUplinkMsgDescription(2, ([station, altim]) => `${station} ALTIMETER ${altim}`, "R", ([station, altim]) => `${station} A${altim}`),
    UM154: createUplinkMsgDescription(0, () => "RADAR SERVICES TERMINATED"),
    UM244: createUplinkMsgDescription(0, () => "IDENTIFICATION TERMINATED"),
    UM191: createUplinkMsgDescription(0, () => "ALL ATS TERMINATED"),
    UM155: createUplinkMsgDescription(1, ([position]) => `RADAR CONTACT ${position}`, "R"),
    UM156: createUplinkMsgDescription(0, () => "RADAR CONTACT LOST", "R"),
    UM193: createUplinkMsgDescription(0, () => "IDENTIFICATION LOST"),
    UM157: createUplinkMsgDescription(1, ([freq]) => `CHECK STUCK MICROPHONE ${freq}`),
    UM158: createUplinkMsgDescription(1, ([letter]) => `ATIS ${letter}`),
    UM212: createUplinkMsgDescription(2, ([apt, letter]) => `${apt} ATIS ${letter} CURRENT`),
    UM214: createUplinkMsgDescription(2, ([runway, rvr]) => `RVR RUNWAY ${runway} ${rvr}`),
    UM224: createUplinkMsgDescription(0, () => "NO DELAY EXPECTED"),
    UM225: createUplinkMsgDescription(0, () => "DELAY NOT DETERMINED"),
    UM226: createUplinkMsgDescription(1, ([apchTime]) => `EXPECTED APPROACH TIME ${apchTime}`),
    // System Management Messages
    UM159: createUplinkMsgDescription(1, ([text]) => `ERROR ${text}`),
    UM160: createUplinkMsgDescription(1, ([text]) => `NEXT DATA AUTHORITY ${text}`),
    UM161: createUplinkMsgDescription(0, () => "END SERVICE"),
    UM162: createUplinkMsgDescription(0, () => "SERVICE UNAVAILABLE"),
    UM234: createUplinkMsgDescription(0, () => "FLIGHT PLAN NOT HELD"),
    UM163: createUplinkMsgDescription(2, ([icaoFacilityDesignation, tp4Table]) => `${icaoFacilityDesignation} ${tp4Table}`),
    UM227: createUplinkMsgDescription(0, () => "LOGICAL ACKNOWLEDGMENT"),
    UM233: createUplinkMsgDescription(0, () => "USE OF LOGICAL ACKNOWLEDGMENT PROHIBITED"),
    // Additional Messages
    UM164: createUplinkMsgDescription(0, () => "WHEN READY"),
    UM230: createUplinkMsgDescription(0, () => "IMMEDIATELY", "N", () => "IMM"),
    UM165: createUplinkMsgDescription(0, () => "THEN"),
    UM166: createUplinkMsgDescription(0, () => "DUE TO TRAFFIC", "N", () => "TFC"),
    UM167: createUplinkMsgDescription(0, () => "DUE TO AIRSPACE RESTRICTION", "N", () => "RES"),
    UM168: createUplinkMsgDescription(0, () => "DISREGARD"),
    UM176: createUplinkMsgDescription(0, () => "MAINTAIN OWN SEPARATION AND VMC"),
    UM177: createUplinkMsgDescription(0, () => "AT PILOTS DISCRETION", "N", () => "PD"),
    UM169: createUplinkMsgDescription(1, ([freetext]) => `${freetext}`, "R"),
    UM170: createUplinkMsgDescription(1, ([msg]) => `${msg}`, "R"),
    UM183: createUplinkMsgDescription(1, ([msg]) => `${msg}`, "R"),
    UM196: createUplinkMsgDescription(1, ([msg]) => `${msg}`, "R"),
    UM203: createUplinkMsgDescription(1, ([msg]) => `${msg}`, "R"),
    UM205: createUplinkMsgDescription(1, ([msg]) => `${msg}`, "R"),
    UM208: createUplinkMsgDescription(1, ([msg]) => `${msg}`, "R"),
    // CPDLC standardized free text uplink messages. See GOLD A.5.1
    UM169q: createUplinkMsgDescription(0, () => "ROGER MAYDAY"),
    UM169r: createUplinkMsgDescription(0, () => "ROGER PAN PAN"),
    UM169ak: createUplinkMsgDescription(0, () => "CONFIRM ADS-C EMERGENCY"),
    UM169s: createUplinkMsgDescription(0, () => `REQUEST RECEIVED EXPECT VOICE RESPONSE`),
    UM169x: createUplinkMsgDescription(0, () => "REQUEST FORWARDED"),
    UM169ab: createUplinkMsgDescription(0, () => "REQUEST AGAIN WITH NEXT UNIT"),
    // standardized free text vertical clearances
    UM169ac: createUplinkMsgDescription(1, ([text]) => `ITP BEHIND ${text}`),
    UM169ad: createUplinkMsgDescription(1, ([text]) => `ITP AHEAD OF ${text}`),
    UM169ae: createUplinkMsgDescription(2, ([arg1, arg2]) => `ITP BEHIND ${arg1} AND BEHIND ${arg2}`),
    UM169af: createUplinkMsgDescription(2, ([arg1, arg2]) => `ITP AHEAD OF ${arg1} AND AHEAD OF ${arg2}`),
    UM169al: createUplinkMsgDescription(2, ([arg1, arg2]) => `ITP BEHIND ${arg1} AND AHEAD OF ${arg2}`),
    // standardized free text speed changes
    UM169p: createUplinkMsgDescription(2, ([speed, until]) => `EXPECT TO MAINTAIN ${speed} UNTIL ${until}`),
    UM169z: createUplinkMsgDescription(0, () => "NO SPEED RESTRICTION"),
    // standardized free text contact/monitor/surveillance requests
    UM169ai: createUplinkMsgDescription(0, () => "TRANSMIT ADS-B IDENT"),
    // standardized free text report/confirmation requests
    UM169b: createUplinkMsgDescription(0, () => "REPORT GROUND SPEED", "R"),
    UM169c: createUplinkMsgDescription(0, () => "STATE PREFERRED LEVEL", "R"),
    UM169d: createUplinkMsgDescription(1, ([fix]) => `REPORT ETA ${fix}`, "R"),
    UM169e: createUplinkMsgDescription(2, ([traffic, etp]) => `REPORT SIGHTING AND PASSING OPPOSITE DIRECTION ${traffic} ETP ${etp}`),
    UM169f: createUplinkMsgDescription(0, () => "ADS-C INDICATES OFF ROUTE. ADVISE INTENTIONS", "R"),
    UM169t: createUplinkMsgDescription(0, () => "ADS-C INDICATES LEVEL DEVIATION. ADVISE INTENTIONS", "R"),
    UM169v: createUplinkMsgDescription(0, () => "ADS-C INDICATES SPEED DEVIATION. ADVISE INTENTIONS", "R"),
    UM169h: createUplinkMsgDescription(0, () => "ADS-C ESTIMATES APPEAR INACCURATE. CHECK FMS", "R"),
    UM169aa: createUplinkMsgDescription(0, () => "STATE TOP OF DESCENT", "R"),
    // standardized free text air traffic advisories
    UM169k: createUplinkMsgDescription(1, ([text]) => `EXPECT SELCAL CHECK HF ${text}`),
    UM169l: createUplinkMsgDescription(1, ([text]) => `EXPECT CPDLC TRANSFER AT ${text}`),
    UM169n: createUplinkMsgDescription(1, ([text]) => `TRAFFIC IS ${text}`),
    UM169ag: createUplinkMsgDescription(0, () => "TRY SATCOM VOICE OR RELAY THROUGH ANOTHER AIRCRAFT"),
    UM169av: createUplinkMsgDescription(1, ([text]) => `SEND NEW ITP REQUEST ELSE IF ABLE ${text}`),
    // Standardized free text system management messages
    UM169j: createUplinkMsgDescription(0, () => "CHECK AND RESPOND TO OPEN CPDLC MESSAGES"),
    UM169au: createUplinkMsgDescription(0, () => "CONFIRM MAX UPLINK DELAY VALUE IS NOT SET"),
    UM169ah: createUplinkMsgDescription(0, () => "MESSAGE NOT SUPPORTED BY THIS ATS UNIT, CONTACT RTF"),
    UM169am: createUplinkMsgDescription(2, ([area, authority]) => `AUTOMATIC TRANSFER OF CPDLC FAILED. WHEN ENTERING ${area} AREA DISCONNECT CPDLC THEN LOGON TO ${authority}`),
    UM169an: createUplinkMsgDescription(0, () => "CONFIRM ADS-C ARMED"),
    UM169ao: createUplinkMsgDescription(1, ([time]) => `ADS-C SHUT DOWN AT ${time}. REVERT TO CPDLC POSITION REPORTS. LEAVE ADS-C ARMED.`),
    UM169at: createUplinkMsgDescription(1, ([time]) => `ADS-C SHUT DOWN AT ${time}. REVERT TO VOICE POSITION REPORTS. LEAVE ADS-C ARMED.`),
    UM169aw: createUplinkMsgDescription(0, () => "RESUME NORMAL ADS-C OPERATIONS. CPDLC AND VOICE POSITION REPORTS NOT REQUIRED."),
    UM169ax: createUplinkMsgDescription(0, () => "CPDLC WILL BE SHUT DOWN. DISCONNECT CPDLC. CONTINUE ON VOICE"),
    UM169ap: createUplinkMsgDescription(3, ([arg1, arg2, arg3]) => `RELAY TO ${arg1} ${arg2} ${arg3}`),
    // Standardized free text military
    UM169aq: createUplinkMsgDescription(1, ([text]) => `MARSA TERMINATED WITH ${text}`),
    UM169ar: createUplinkMsgDescription(2, ([start, end]) => `CLEARED TO DEPLOY FOR AIR REFUEL AT ${start} UNTIL ${end}`),
    UM169as: createUplinkMsgDescription(0, () => "CLEARED TO CONDUCT REFUELING"),
    UM169rj: createUplinkMsgDescription(0, () => "DOWNLINK REJECTED - UPLINK OF SAME TYPE EXISTS"),
    UM169ne: createUplinkMsgDescription(0, () => "YOUR LAST CPDLC MESSAGE NOT EXPECTED. CONTACT ATC BY VOICE"),
    UM169dmns: createUplinkMsgDescription(0, () => "DOWNLINK MESSAGE NOT SUPPORTED"),
    UM169rns: createUplinkMsgDescription(0, () => "RESPONSE TO MESSAGE NOT SHOWN TO ATC - CONTACT ATC BY VOICE."),
    UM169hoppie: createUplinkMsgDescription(0, () => "ATC COMM TERMINATED"), // stupid hoppie
    UM169wu: createUplinkMsgDescription(1, ([freetext]) => `${freetext}`, "WU"),
    DM0: createDownlinkMsgDescription(0, () => "WILCO"),
    DM1: createDownlinkMsgDescription(0, () => "UNABLE"),
    DM2: createDownlinkMsgDescription(0, () => "STANDBY"),
    DM3: createDownlinkMsgDescription(0, () => "ROGER"),
    DM4: createDownlinkMsgDescription(0, () => "AFFIRM"),
    DM5: createDownlinkMsgDescription(0, () => "NEGATIVE"),
    DM6: createDownlinkMsgDescription(1, ([alt]) => `REQUEST ${alt}`, "Y", ([alt]) => `REQ ${alt}`),
    DM7: createDownlinkMsgDescription(2, ([lowerAlt, upperAlt]) => `REQUEST BLOCK ${lowerAlt} TO ${upperAlt}`, "Y", ([lowerAlt, upperAlt]) => `REQ ${lowerAlt}B${upperAlt}`),
    DM8: createDownlinkMsgDescription(1, ([alt]) => `REQUEST CRUISE CLIMB TO ${alt}`, "Y", ([alt]) => `REQ CRZ ${alt}`),
    DM9: createDownlinkMsgDescription(2, ([alt]) => `REQUEST CLIMB TO ${alt}`, "Y", ([alt]) => `REQ ${UP_ARROW}${alt}`),
    DM10: createDownlinkMsgDescription(1, ([alt]) => `REQUEST DESCENT TO ${alt}`, "Y", ([alt]) => `REQ ${DOWN_ARROW}${alt}`),
    DM11: createDownlinkMsgDescription(2, ([fix, alt]) => `AT ${fix} REQUEST CLIMB TO ${alt}`, "Y", ([fix, alt]) => `AT ${fix} REQ ${UP_ARROW}${alt}`),
    DM12: createDownlinkMsgDescription(2, ([fix, alt]) => `AT ${fix} REQUEST DESCENT TO ${alt}`, "Y", ([fix, alt]) => `AT ${fix} REQ ${DOWN_ARROW}${alt}`),
    DM13: createDownlinkMsgDescription(2, ([time, alt]) => `AT TIME ${time} REQUEST CLIMB TO ${alt}`, "Y", ([time, alt]) => `AT ${time} REQ ${UP_ARROW}${alt}`),
    DM14: createDownlinkMsgDescription(2, ([time, alt]) => `AT TIME ${time} REQUEST DESCENT TO ${alt}`, "Y", ([time, alt]) => `AT ${time} REQ ${DOWN_ARROW}${alt}`),
    DM69: createDownlinkMsgDescription(0, () => "REQUEST VMC DESCENT", "Y"),
    // Lateral Off-set Requests
    DM15: createDownlinkMsgDescription(2, ([distance, dir]) => `REQUEST OFFSET ${distance} ${dir} OF ROUTE`, "Y", ([distance, dir]) => `REQ OFFSET ${distance} ${dir}`),
    DM16: createDownlinkMsgDescription(3, ([fix, deg, dir]) => `AT ${fix} REQUEST OFFSET ${deg} ${dir} OF ROUTE`, "Y", ([fix, deg, dir]) => `AT ${fix} REQ OFFSET ${deg} ${dir}`),
    DM17: createDownlinkMsgDescription(3, ([time, deg, dir]) => `AT ${time} REQUEST OFFSET ${deg} ${dir} OF ROUTE`, "Y", ([time, deg, dir]) => `AT ${time} REQ OFFSET ${deg} ${dir}`),
    // Speed requests
    DM18: createDownlinkMsgDescription(1, ([speed]) => `REQUEST ${speed}`, "Y", ([speed]) => `REQ ${speed}`),
    DM19: createDownlinkMsgDescription(2, ([lowerSpd, upperSpd]) => `REQUEST ${lowerSpd} TO ${upperSpd}`, "Y", ([lowerSpd, upperSpd]) => `REQ ${lowerSpd} TO ${upperSpd}`),
    // Voice contact requests
    DM20: createDownlinkMsgDescription(0, () => "REQUEST VOICE CONTACT", "Y", () => "REQ VOICE CONTACT"),
    DM21: createDownlinkMsgDescription(1, ([freq]) => `REQUEST VOICE CONTACT ${freq}`, "Y", ([freq]) => `REQ VOICE CONTACT ${freq}`),
    // Route modification requests
    DM22: createDownlinkMsgDescription(1, ([fix]) => `REQUEST DIRECT TO ${fix}`, "Y", ([fix]) => `REQ DRCT ${fix}`),
    DM23: createDownlinkMsgDescription(1, ([procedure]) => `REQUEST ${procedure}`, "Y", ([procedure]) => `REQ ${procedure}`),
    DM24: createDownlinkMsgDescription(1, ([route]) => `REQUEST ${route}`, "Y", () => `REQ RTE`),
    DM25: createDownlinkMsgDescription(0, () => `REQUEST CLEARANCE`, "Y"),
    DM26: createDownlinkMsgDescription(2, ([fix, route]) => `REQUEST WEATHER DEVIATION TO ${fix} VIA ${route}`, "Y"),
    DM27: createDownlinkMsgDescription(2, ([distance, dir]) => `REQUEST WEATHER DEVIATION UP TO ${distance} ${dir} OF ROUTE`, "Y", ([distance, dir]) => `REQ WX DEV ${distance} ${dir}`),
    DM70: createDownlinkMsgDescription(1, ([degrees]) => `REQUEST HEADING ${degrees}`, "Y", ([degrees]) => `REQ HDG ${degrees}`),
    DM71: createDownlinkMsgDescription(1, ([degrees]) => `REQUEST GROUND TRACK ${degrees}`, "Y", ([degrees]) => `REQ TRK ${degrees}`),
    // Reports
    DM28: createDownlinkMsgDescription(1, ([alt]) => `LEAVING ${alt}`),
    DM29: createDownlinkMsgDescription(1, ([alt]) => `CLIMBING TO ${alt}`),
    DM30: createDownlinkMsgDescription(1, ([alt]) => `DESCENDING TO ${alt}`),
    DM31: createDownlinkMsgDescription(1, ([alt]) => `PASSING ${alt}`),
    DM32: createDownlinkMsgDescription(1, ([alt]) => `PRESENT LEVEL ${alt}`, "N", ([alt]) => `CURRENT ALT ${alt}`),
    DM33: createDownlinkMsgDescription(1, ([pos]) => `PRESENT POSITION ${pos}`),
    DM34: createDownlinkMsgDescription(1, ([speed]) => `PRESENT SPEED ${speed}`, "N", ([speed]) => `CURRENT SPD ${speed}`),
    DM35: createDownlinkMsgDescription(1, ([degrees]) => `PRESENT HEADING ${degrees}`),
    DM36: createDownlinkMsgDescription(1, ([degrees]) => `PRESENT GROUND TRACK ${degrees}`),
    DM37: createDownlinkMsgDescription(1, ([alt]) => `LEVEL ${alt}`),
    DM38: createDownlinkMsgDescription(1, ([alt]) => `ASSIGNED ALTITUDE ${alt}`, "N", ([alt]) => `ASSIGNED ALT ${alt}`),
    DM76: createDownlinkMsgDescription(2, ([lower, upper]) => `REACHING BLOCK ${lower} TO ${upper}`),
    DM77: createDownlinkMsgDescription(2, ([lower, upper]) => `ASSIGNED BLOCK ${lower} TO ${upper}`, "N", ([lower, upper]) => `ASSIGNED ALT ${lower}B${upper}`),
    DM39: createDownlinkMsgDescription(1, ([spd]) => `ASSIGNED SPEED ${spd}`, "N", ([spd]) => `ASSIGNED SPD ${spd}`),
    DM40: createDownlinkMsgDescription(1, ([route]) => `ASSIGNED ROUTE ${route}`, "N", () => `ASSIGNED RTE`),
    DM41: createDownlinkMsgDescription(0, () => `BACK ON ROUTE`, "N", () => `BACK ON RTE`),
    DM114: createDownlinkMsgDescription(0, () => `CLEAR OF WEATHER`),
    DM42: createDownlinkMsgDescription(1, ([fix]) => `NEXT WAYPOINT ${fix}`),
    DM43: createDownlinkMsgDescription(1, ([time]) => `NEXT WAYPOINT ETA ${time}`),
    DM44: createDownlinkMsgDescription(1, ([fix]) => `ENSUING WAYPOINT ${fix}`),
    DM45: createDownlinkMsgDescription(1, ([fix]) => `REPORTED WAYPOINT ${fix}`),
    DM46: createDownlinkMsgDescription(1, ([fix]) => `REPORTED WAYPOINT ${fix}`),
    DM47: createDownlinkMsgDescription(1, ([squawk]) => `SQUAWKING ${squawk}`),
    DM48: createDownlinkMsgDescription(1, ([fix]) => `POSITION REPORT ${fix}`),
    DM79: createDownlinkMsgDescription(1, ([letter]) => `ATIS ${letter}`),
    DM89: createDownlinkMsgDescription(2, ([name, freq]) => `MONITORING ${name} ${freq}`),
    DM102: createDownlinkMsgDescription(0, () => `MONITORING LANDING REPORT`),
    DM106: createDownlinkMsgDescription(1, ([alt]) => `PREFERRED LEVEL ${alt}`),
    DM109: createDownlinkMsgDescription(1, ([time]) => `TOP OF DESCENT ${time}`, "N", ([time]) => `TOD ${time}`),
    // Negotiation requests
    DM49: createDownlinkMsgDescription(1, ([speed]) => `WHEN CAN WE EXPECT ${speed}`, "Y"),
    DM50: createDownlinkMsgDescription(2, ([lowerSpd, upperSpd]) => `WHEN CAN WE EXPECT ${lowerSpd} TO ${upperSpd}`, "Y"),
    DM51: createDownlinkMsgDescription(0, () => "WHEN CAN WE EXPECT BACK ON ROUTE", "Y"),
    DM52: createDownlinkMsgDescription(0, () => "WHEN CAN WE EXPECT LOWER LEVEL", "Y"),
    DM53: createDownlinkMsgDescription(0, () => "WHEN CAN WE EXPECT HIGHER LEVEL", "Y"),
    DM54: createDownlinkMsgDescription(1, ([alt]) => `WHEN CAN WE EXPECT CRUISE CLIMB TO ${alt}`, "Y"),
    DM87: createDownlinkMsgDescription(1, ([alt]) => `WHEN CAN WE EXPECT CLIMB TO ${alt}`, "Y"),
    DM88: createDownlinkMsgDescription(1, ([alt]) => `WHEN CAN WE EXPECT DESCENT TO ${alt}`, "Y"),
    // Emergency messages
    DM55: createDownlinkMsgDescription(0, () => "PAN PAN PAN", "Y"),
    DM56: createDownlinkMsgDescription(0, () => "MAYDAY MAYDAY MAYDAY", "Y"),
    DM112: createDownlinkMsgDescription(0, () => "SQUAWKING 7500", "Y"),
    DM57: createDownlinkMsgDescription(2, ([fuel, souls]) => `${fuel} OF FUEL REMAINING AND ${souls} SOULS ON BOARD`, "Y"),
    DM58: createDownlinkMsgDescription(0, () => "CANCEL EMERGENCY", "Y"),
    DM59: createDownlinkMsgDescription(2, ([to, via]) => `DIVERTING TO ${to} VIA ${via}`),
    DM60: createDownlinkMsgDescription(2, ([distance, direction]) => `OFFSETTING ${distance} ${direction} OF ROUTE`),
    DM61: createDownlinkMsgDescription(1, ([alt]) => `DESCENDING TO ${alt}`),
    DM80: createDownlinkMsgDescription(2, ([distance, direction]) => `DEVIATING ${distance} ${direction} OF ROUTE`),
    DM73: createDownlinkMsgDescription(1, ([versionNumber]) => `${versionNumber}`),
    // System management messages
    DM62: createDownlinkMsgDescription(1, ([error]) => `ERROR ${error}`),
    DM63: createDownlinkMsgDescription(0, () => "NOT CURRENT DATA AUTHORITY"),
    DM99: createDownlinkMsgDescription(0, () => "CURRENT DATA AUTHORITY"),
    // ground system is not designated as the next data authority (NDA)
    DM64: createDownlinkMsgDescription(1, ([icaoFacilityDesignator]) => `${icaoFacilityDesignator}`),
    DM107: createDownlinkMsgDescription(0, () => "NOT AUTHORIZED NEXT DATA AUTHORITY"),
    DM100: createDownlinkMsgDescription(0, () => "LOGICAL ACKNOWLEDGEMENT"),
    // Additional Messages
    DM65: createDownlinkMsgDescription(0, () => "DUE TO WEATHER", "N", () => "WX"),
    DM66: createDownlinkMsgDescription(0, () => "DUE TO AIRCRAFT PERFORMANCE", "N", () => "ACFT PERF"),
    DM74: createDownlinkMsgDescription(0, () => "REQUEST TO MAINTAIN OWN SEPARATION AND VMC"),
    DM75: createDownlinkMsgDescription(0, () => "AT PILOT'S DISCRETION", "N", () => "PD"),
    DM101: createDownlinkMsgDescription(0, () => "REQUEST END OF SERVICE"),
    DM103: createDownlinkMsgDescription(0, () => "CANCELLING IFR", "Y", () => "CNCL IFR"),
    DM108: createDownlinkMsgDescription(0, () => "DE-ICING COMPLETE"),
    // Free text - normal
    DM67: createDownlinkMsgDescription(1, ([msg]) => `${msg}`),
    // Free text - distress
    DM68: createDownlinkMsgDescription(1, ([msg]) => `${msg}`, "Y"),
    // Negotiation responses
    DM81: createDownlinkMsgDescription(2, ([alt, time]) => `WE CAN ACCEPT ${alt} AT ${time}`),
    DM82: createDownlinkMsgDescription(1, ([alt]) => `WE CANNOT ACCEPT ${alt}`),
    // Standardized Free Text downlink messages
    DM67ad: createDownlinkMsgDescription(2, ([arg1, arg2]) => `REQUEST TAILORED ARRIVAL ${arg1} ${arg2}`),
    DM67a: createDownlinkMsgDescription(2, ([arg1, arg2]) => `ITP ${arg1} BEHIND ${arg2}`),
    DM67r: createDownlinkMsgDescription(2, ([arg1, arg2]) => `ITP ${arg1} AHEAD OF ${arg2}`),
    DM67s: createDownlinkMsgDescription(4, ([arg1, arg2, arg3, arg4]) => `ITP ${arg1} BEHIND ${arg2} AND ${arg3} BEHIND ${arg4}`),
    DM67t: createDownlinkMsgDescription(4, ([arg1, arg2, arg3, arg4]) => `ITP ${arg1} AHEAD OF ${arg2} AND ${arg3} AHEAD OF ${arg4}`),
    DM67ag: createDownlinkMsgDescription(4, ([arg1, arg2, arg3, arg4]) => `ITP ${arg1} BEHIND ${arg2} AND ${arg3} AHEAD OF ${arg4}`),
    // Standardized free text reports
    DM67k: createDownlinkMsgDescription(2, ([arg1, arg2]) => `REVISED ETA ${arg1} ${arg2}`),
    DM67l: createDownlinkMsgDescription(0, () => "GROUND SPEED"),
    DM67m: createDownlinkMsgDescription(1, ([text]) => `PREFERRED LEVEL ${text}`),
    DM67n: createDownlinkMsgDescription(2, ([arg1, arg2]) => `ETA ${arg1} ${arg2}`),
    DM67o: createDownlinkMsgDescription(1, ([text]) => `${text} SIGHTED AND PASSED`),
    DM67p: createDownlinkMsgDescription(1, ([text]) => `${text} NOT SIGHTED`),
    DM67q: createDownlinkMsgDescription(0, () => "TRAFFIC SIGHTED"),
    DM67v: createDownlinkMsgDescription(1, ([text]) => `TOP OF DESCENT ${text}`),
    DM67aa: createDownlinkMsgDescription(2, ([arg1, arg2]) => `MONITORING ${arg1} ${arg2}`),
    // Standardized free text system management messages
    DM67u: createDownlinkMsgDescription(0, () => "UPLINK DELAYED IN NETWORK AND REJECTED - RESEND OR CONTACT BY VOICE"),
    DM92u: createDownlinkMsgDescription(0, () => "UPLINK DELAYED IN NETWORK AND REJECTED - RESEND OR CONTACT BY VOICE"),
    DM67j: createDownlinkMsgDescription(0, () => "CPDLC TRANSFER FAILURE"),
    DM67ab: createDownlinkMsgDescription(0, () => "ADS-C RESET"),
    DM67ae: createDownlinkMsgDescription(2, ([arg1, arg2]) => `RELAY FROM ${arg1} ${arg2}`),
    DM67af: createDownlinkMsgDescription(0, () => "TIMER NOT AVAILABLE"),
    DM67ac: createDownlinkMsgDescription(2, ([arg1, arg2]) => `AND ${arg1} ${arg2}`),
    // Standardized free text negotiation responses
    DM67b: createDownlinkMsgDescription(2, ([arg1, arg2]) => `WE CAN ACCEPT ${arg1} AT ${arg2}`),
    DM67c: createDownlinkMsgDescription(2, ([arg1, arg2]) => `WE CAN ACCEPT ${arg1} AT ${arg2}`),
    DM67d: createDownlinkMsgDescription(3, ([arg1, arg2, arg3]) => `WE CAN ACCEPT ${arg1} ${arg2} AT ${arg3}`),
    DM67e: createDownlinkMsgDescription(1, ([text]) => `WE CANNOT ACCEPT ${text}`),
    DM67f: createDownlinkMsgDescription(1, ([text]) => `WE CANNOT ACCEPT ${text}`),
    DM67g: createDownlinkMsgDescription(2, ([arg1, arg2]) => `WE CANNOT ACCEPT ${arg1} ${arg2}`),
    DM67h: createDownlinkMsgDescription(1, ([alt]) => `WHEN CAN WE EXPECT CLIMB TO ${alt}`),
    DM67i: createDownlinkMsgDescription(1, ([alt]) => `WHEN CAN WE EXPECT DESCENT TO ${alt}`),
    DM67w: createDownlinkMsgDescription(2, ([start, end]) => `TO DELAY FOR AIR REFUEL AT ${start} UNTIL ${end}`),
    DM67x: createDownlinkMsgDescription(1, ([time]) => `EXPECT END OF REFUEL AT ${time}`),
    DM67y: createDownlinkMsgDescription(2, ([arg1, arg2]) => `JOINING ALTRV ${arg1} AT ${arg2}`),
    DM67z: createDownlinkMsgDescription(1, ([text]) => `ACCEPT MARSA WITH ${text}`),
};
export const pidResponseTypes = [
    "UM0",
    "UM1",
    "UM2",
    "UM3",
    "UM4",
    "UM5",
    "UM211",
    "UM235",
    "UM237",
];
export const altMsgTypes = [
    "UM6",
    "UM7",
    "UM8",
    "UM9",
    "UM10",
    "UM11",
    "UM12",
    "UM19",
    "UM20",
    "UM21",
    "UM22",
    "UM23",
    "UM24",
    "UM25",
    "UM26",
    "UM27",
    "UM28",
    "UM29",
    "UM192",
    "UM209",
    "UM30",
    "UM31",
    "UM32",
    "UM34",
    "UM35",
    "UM219",
    "UM220",
    "UM36",
    "UM37",
    "UM38",
    "UM39",
    "UM171",
    "UM172",
    "UM173",
    "UM174",
];
export const speedMsgTypes = [
    "UM100",
    "UM101",
    "UM102",
    "UM103",
    "UM104",
    "UM105",
    "UM106",
    "UM107",
    "UM108",
    "UM109",
    "UM110",
    "UM111",
    "UM112",
    "UM113",
    "UM114",
    "UM115",
    "UM188",
    "UM189",
    "UM222",
    "UM223",
];
export const headingMsgTypes = ["UM94", "UM95", "UM96", "UM190", "UM215"];
export const routeMsgTypes = [
    "UM73",
    "UM74",
    "UM75",
    "UM76",
    "UM77",
    "UM78",
    "UM79",
    "UM80",
    "UM81",
    "UM236",
    "UM82",
    "UM83",
    "UM84",
    "UM85",
    "UM86",
    "UM87",
    "UM88",
    "UM89",
    "UM90",
    "UM91",
];
export const holdMsgTypes = [
    "UM91",
    "UM92",
    "UM93",
    "UM94",
    "UM95",
    "UM215",
    "UM190",
    "UM96",
    "UM97",
    "UM221",
    "UM98",
    "UM99",
];
export const downlinkResponseMsgTypes = ["DM0", "DM1", "DM2", "DM3", "DM4", "DM5"];
export const emergencyMsgTypes = [
    "DM55",
    "DM56",
    "DM57",
    "DM58",
    "DM59",
    "DM60",
    "DM61",
    "DM80",
];
export const reportMsgTypes = [
    "DM28",
    "DM29",
    "DM30",
    "DM31",
    "DM32",
    "DM33",
    "DM34",
    "DM35",
    "DM36",
    "DM37",
    "DM38",
    "DM76",
    "DM77",
    "DM39",
    "DM40",
    "DM41",
    "DM42",
    "DM43",
    "DM44",
    "DM45",
    "DM46",
    "DM47",
    "DM48",
    "DM79",
    "DM89",
    "DM102",
    "DM106",
    "DM109",
    "DM114",
];
const voiceContactRequestMsgTypes = ["DM20", "DM21"];
export function getDownlinkMessageCategory(msgType) {
    if (voiceContactRequestMsgTypes.includes(msgType)) {
        return "voiceContactRequest";
    }
    if (emergencyMsgTypes.includes(msgType)) {
        return "emergencyDownlink";
    }
    if (reportMsgTypes.includes(msgType) || cpdlcMsgDescriptionMap[msgType].responseAttr === "N") {
        return "reportDownlink";
    }
    if (msgType.startsWith("DM")) {
        return "normalDownlink";
    }
    return null;
}
export function getUplinkMessageCategory(msgType) {
    if (altMsgTypes.includes(msgType)) {
        return "altUplink";
    }
    if (speedMsgTypes.includes(msgType)) {
        return "speedUplink";
    }
    if (headingMsgTypes.includes(msgType)) {
        return "headingUplink";
    }
    if (routeMsgTypes.includes(msgType)) {
        return "routeUplink";
    }
    if (holdMsgTypes.includes(msgType)) {
        return "holdUplink";
    }
    if (msgType.startsWith("UM")) {
        return "genericUplink";
    }
    return null;
}
export const standbyMessages = ["UM1", "DM2"];
const _dueToReasonMsgTypes = ["UM166", "UM167", "DM65", "DM66"];
export const dueToReasonMsgTypes = _dueToReasonMsgTypes;
export const uplinkMessageTypes = Object.keys(cpdlcMsgDescriptionMap).filter((k) => k.startsWith("UM"));
export const downlinkMessageTypes = Object.keys(cpdlcMsgDescriptionMap).filter((k) => k.startsWith("DM"));
export function isDownlinkMessageType(msgType) {
    return msgType.startsWith("DM") && Object.keys(cpdlcMsgDescriptionMap).includes(msgType);
}
export function isUplinkMessageType(msgType) {
    return msgType.startsWith("UM") && Object.keys(cpdlcMsgDescriptionMap).includes(msgType);
}
export function createCpdlcMsgElement(msgType, parameters, shortParameters) {
    return {
        type: msgType,
        shortParameters,
        parameters,
    };
}
export function isDownlinkMessage(msg) {
    return msg.type === "DM";
}
export function isUplinkMessage(msg) {
    return msg.type === "UM";
}
let cpdlcMsgIdCounter = 1;
export function generateCpdlcMsgId() {
    return cpdlcMsgIdCounter++;
}
export function getResponseAttribute(elements) {
    return (elements.length > 0 ? cpdlcMsgDescriptionMap[elements[0].type].responseAttr : "NE");
}
export class CpdlcMessage {
    type;
    elements;
    referenceMessageId;
    responseAttribute;
    constructor(type, elements, referenceMessageId, responseAttribute = getResponseAttribute(elements)) {
        this.type = type;
        this.elements = elements;
        this.referenceMessageId = referenceMessageId;
        this.responseAttribute = responseAttribute;
        if (["NE", "N"].includes(responseAttribute)) {
            this.status = "CLOSED";
        }
    }
    id = generateCpdlcMsgId();
    status = "OPEN";
    timeout = false;
}
//# sourceMappingURL=cpdlcMessage.js.map